import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../../components/contentwrapper/ContentWrapper'
import { Link, useParams } from 'react-router-dom'
import { fetchAllDataAPI, getSingleDataFromDataBase } from '../../utils/api'
import { FaAddressBook, FaBirthdayCake, FaEdit, FaInfo, FaMoneyCheckAlt, FaPassport, FaRupeeSign, FaUserEdit } from 'react-icons/fa'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { toast } from 'react-toastify'
import { BASEEMPURLS } from '../../utils/BaseUrl'
import avatar from "../../assets/avatar.webp"
import img1 from "../../assets/avatar-6.png"
import img2 from "../../assets/avatar-7.png"
import img3 from "../../assets/avatar-8.png"
import img4 from "../../assets/avatar-9.png"
import img5 from "../../assets/avatar-10.png"
import { FcAbout, FcApproval, FcCableRelease, FcCalendar, FcCallback, FcDebian, FcEngineering, FcGlobe, FcLinux, FcReadingEbook, FcSimCardChip } from 'react-icons/fc'
import { TbPointFilled } from 'react-icons/tb'
import { FaMessage } from 'react-icons/fa6'
import { MdEmail } from 'react-icons/md'
import { PiGenderMale } from "react-icons/pi";
import { LiaBirthdayCakeSolid } from "react-icons/lia";
import { RiPassExpiredFill } from "react-icons/ri";
import { Col, Row } from 'react-bootstrap'
import { GiSkills } from 'react-icons/gi'
import { CiBank } from "react-icons/ci";
import { GrDocumentTest } from "react-icons/gr";

const EmployeeDetails = () => {
    const [empdetail, setEmpDetail] = useState([]);
    const [employee, setEmployee] = useState([]);
    const [empdata, setEmpdata] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { slug } = useParams();

    useEffect(() => {
        getEmpDetails(slug)
        getAllEmployee();
        getDashboardData()
    }, [slug]);

    const getEmpDetails = (slug) => {
        getSingleDataFromDataBase(`hr-get-employee-details/${slug}`).then((res) => {
            if (res.data.status === 1) {
                setEmpDetail(...[res.data.employee]);
            }
        })
    }
    const getAllEmployee = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-all-employee').then((res) => {
            if (res.data.status === 1) {
                setIsLoading(false);
                setEmployee(...[res.data.employee]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }
    const getDashboardData = () => {
        fetchAllDataAPI('hr-dashboard-about-emp-data').then((res) => {
            if (res.data.status === 1) {
                setEmpdata(...[res.data.empdata])
            }
            else {
                toast.warning("Check you connection");
            }
        })
    }
    return (
        <div className="employeepage">
            <Helmet>
                <title>SATKARTAR::HR::EMPLOYEES DETAILS</title>
            </Helmet>
            <ContentWrapper>
                <div className="employeedetail">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/employee">Employee </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Employee Details</li>
                                    <li className="breadcrumb-item active" aria-current="page">{slug}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="main-body">
                        <div className="row">
                            <div className="col-lg-4 colclass">
                                <div className="card card-bg-1">
                                    <div className="card-body p-0">
                                        <span className="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2">
                                            <img className="avatarimg" alt="Img" src={avatar} />
                                        </span>
                                        <div className="text-center px-3 pb-3 border-bottom mt-2">
                                            <div className="mb-3">
                                                <h5 className="d-flex align-items-center justify-content-center mb-1 empnames">Sushil Kumar Raj <FcApproval />
                                                </h5>
                                                <span className="badge badge-soft-dark fw-medium me-2">
                                                    <TbPointFilled />
                                                    Software Developer
                                                </span>
                                                <span className="badge badge-soft-secondary fw-medium">
                                                    10+ years of Experience
                                                </span>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center">
                                                        <FcSimCardChip className="me-2" />
                                                        Emp ID
                                                    </span>
                                                    <p className="text-dark">SK-0024</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center">
                                                        <FcEngineering className="me-2" />
                                                        Team
                                                    </span>
                                                    <p className="text-dark">UI/UX Design</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><FcCalendar className="me-2" />Date Of Join</span>
                                                    <p className="text-dark">1st Jan 2023</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <span className="d-inline-flex align-items-center">
                                                        <FcCalendar className="me-2" />Reporting Head
                                                    </span>
                                                    <div className="d-flex align-items-center">
                                                        <span className="avatar avatar-sm avatar-rounded me-2">
                                                            <img alt="Img" src={avatar} />
                                                        </span>
                                                        <p className="text-gray-9 mb-0">Sushil Kumar Raj</p>
                                                    </div>
                                                </div>
                                                <div className="btndiv">
                                                    <div>
                                                        <button className="btneditinfo"><FaEdit className="svgimg" /> Edit Info</button>
                                                    </div>
                                                    <div>
                                                        <button className="btneditmsg"><FaMessage className="svgimg" /> Send Message</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="basicinfo">
                                            <div className="basicinfobg">
                                                <div className="d-flex align-items-center justify-content-between mb-2 infoheading">
                                                    <h6>Basic information</h6>
                                                    <button className="btnsvg"><FaEdit className="svgimg" /></button>
                                                </div>
                                            </div>
                                            <div className="p-3 border-bottom">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><FcCallback className="me-2" />Phone</span>
                                                    <p className="text-dark">9876543210</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><MdEmail className="me-2" />Email</span>perralt12@example.com
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><PiGenderMale className="me-2" />Gender</span>
                                                    <p className="text-dark text-end">Male</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center">
                                                        <LiaBirthdayCakeSolid className="me-2" />Birdthday</span>
                                                    <p className="text-dark text-end">24th July 2000</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <span className="d-inline-flex align-items-center"><FaAddressBook className="me-2" />Address</span>
                                                    <p className="text-dark text-end">1861 Bayonne Ave, <br /> Manchester, NJ, 08759</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="basicinfobg">
                                                <div className="d-flex align-items-center justify-content-between mb-2 infoheading">
                                                    <h6>Personal Information</h6>
                                                    <button className="btnsvg"><FaEdit className="svgimg" /></button>
                                                </div>
                                            </div>
                                            <div className="p-3 border-bottom">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><FaPassport className="me-2" />Passport No</span>
                                                    <p className="text-dark">QRET4566FGRT</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><RiPassExpiredFill className="me-2" />Passport Exp Date</span>
                                                    <p className="text-dark text-end">15 May 2029</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><PiGenderMale className="me-2" />Nationality</span>
                                                    <p className="text-dark text-end">Indian</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><FcDebian className="me-2" />Religion</span>
                                                    <p className="text-dark text-end">Christianity</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><FcLinux className="me-2" />Marital status</span>
                                                    <p className="text-dark text-end">Yes</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="d-inline-flex align-items-center"><FcReadingEbook className="me-2" />Employment of spouse</span>
                                                    <p className="text-dark text-end">No</p>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <span className="d-inline-flex align-items-center"><FcCableRelease className="me-2" />No. of children</span>
                                                    <p className="text-dark text-end">2</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="basicinfobg">
                                                <div className="d-flex align-items-center justify-content-between mb-2 infoheading">
                                                    <h6>Emergency Contact Number</h6>
                                                    <button className="btnsvg"><FaEdit className="svgimg" /></button>
                                                </div>
                                            </div>
                                            <div class="card-body p-0">
                                                <div class="p-2 border-bottom">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div>
                                                            <span class="d-inline-flex align-items-center">Primary</span>
                                                            <h6 class="d-flex align-items-center fw-medium mt-1">Adrian Peralt <span class="d-inline-flex mx-1"><TbPointFilled /></span>Father</h6>
                                                        </div>
                                                        <p class="text-dark">+91 827 2685 598</p>
                                                    </div>
                                                </div>
                                                <div class="p-2 border-bottom">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div>
                                                            <span class="d-inline-flex align-items-center">Secondry</span>
                                                            <h6 class="d-flex align-items-center fw-medium mt-1">Karen Wills <span class="d-inline-flex mx-1"><TbPointFilled />
                                                            </span>Mother</h6>
                                                        </div>
                                                        <p class="text-dark">+91 989 7774 787</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="basicinfobg">
                                                <div className="d-flex align-items-center justify-content-between mb-2 infoheading">
                                                    <h6>Skill Set</h6>
                                                    <button className="btnsvg"><FaEdit className="svgimg" /></button>
                                                </div>
                                            </div>
                                            <div className="p-2 mb-2">
                                                <div className="empskills">
                                                    <span className="skilldetail">Php</span>
                                                    <span className="skilldetail">Codeigniter</span>
                                                    <span className="skilldetail">Laravel</span>
                                                    <span className="skilldetail">React JS</span>
                                                    <span className="skilldetail">Node JS</span>
                                                    <span className="skilldetail">MongoDB</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 colclass empinfodetails">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="infoheadings">
                                            <h6 className="card-title mt-1 empheading">
                                                <FcAbout />About Employee
                                            </h6>
                                            <button className="btnsvg"><FaEdit /></button>
                                        </div>
                                        <hr />
                                        <div className="col-md-12">
                                            <div className="row mb-2">
                                                <p>As an award winning designer, I deliver exceptional quality work and bring value to your brand! With 10 years of experience and 350+ projects completed worldwide with satisfied customers, I developed the 360° brand approach, which helped me to create numerous brands that are relevant, meaningful and loved.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="infoheadings">
                                            <h6 className="card-title mt-1 empheading">
                                                <FaInfo />Family Information
                                            </h6>
                                            <button className="btnsvg"><FaEdit /></button>
                                        </div>
                                        <hr />
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Father Name</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>Test</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Mother Name</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>Test</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Spouse Name</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>Test</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Alternate Mobile</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>9876543210</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Personal Email</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>test@gmail.com</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Aniversary Date</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>2025-04-25</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Total Siblings</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>2</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Permanent Address</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>6th Floor, Unit Number 603, Mercantile House, K.G. Marg, New Delhi, Delhi, 110001</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body mb-4">
                                        <div className="infoheadings">
                                            <h6 className="card-title mt-1 empheading">
                                                <FaInfo />Education Details
                                            </h6>
                                            <button className="btnsvg"><FaEdit /></button>
                                        </div>
                                        <hr />
                                        <div className="col-md-12">
                                            <div className="row mb-2">
                                                <div className="col-md-1 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafotitle">
                                                            <span>#</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafotitle">
                                                            <span>Course</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafotitle">
                                                            <span>Brach/Specialization</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafotitle">
                                                            <span>Year Of Completion</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafotitle">
                                                            <span>CGPA/Percentage</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafotitle">
                                                            <span>University/College</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Row>
                                                <div className="col-md-1 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>1</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>B-Tech</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>Computer Science Engg.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>2016</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>70%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>BSEB Patna</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                            <Row className="mt-2">
                                                <div className="col-md-1 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>2</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>B-Tech</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>Computer Science Engg.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>2016</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>70%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>BSEB Patna</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                            <Row className="mt-2">
                                                <div className="col-md-1 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>3</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>B-Tech</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>Computer Science Engg.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>2016</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>70%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className="educafo">
                                                        <div className="educafosession">
                                                            <span>BSEB Patna</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                                <Row>
                                    <Col sm="12" md="6" className="colclasss">
                                        <div className="card">
                                            <div className="card-body mb-2">
                                                <div className="infoheadings">
                                                    <h6 className="card-title mt-1 empheading">
                                                        <FcGlobe />Experience
                                                    </h6>
                                                    <button className="btnsvg"><FaEdit /></button>
                                                </div>
                                                <hr />
                                                <div className="col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="empexinfo">
                                                                <div className="empexinfotitle">
                                                                    <p>Google</p>
                                                                    <span>UI/UX Developer</span>
                                                                </div>
                                                                <div className="empexinfosession">
                                                                    <span>2024-2025</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mt-2">
                                                            <div className="empexinfo">
                                                                <div className="empexinfotitle">
                                                                    <p>Google</p>
                                                                    <span>UI/UX Developer</span>
                                                                </div>
                                                                <div className="empexinfosession">
                                                                    <span>2024-2025</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mt-2">
                                                            <div className="empexinfo">
                                                                <div className="empexinfotitle">
                                                                    <p>Google</p>
                                                                    <span>UI/UX Developer</span>
                                                                </div>
                                                                <div className="empexinfosession">
                                                                    <span>2024-2025</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col sm="12" md="6" className="colclasss">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="infoheadings">
                                                    <h6 className="card-title mt-1 empheading">
                                                        <GiSkills />Skills
                                                    </h6>
                                                    <button className="btnsvg"><FaEdit /></button>
                                                </div>
                                                <hr />
                                                <div className="col-md-12">
                                                    <div className="row mb-4">
                                                        <div className="empinfoname">
                                                            <span className="skilldetail">Php</span>
                                                            <span className="skilldetail">Codeigniter</span>
                                                            <span className="skilldetail">Laravel</span>
                                                            <span className="skilldetail">React JS</span>
                                                            <span className="skilldetail">Node JS</span>
                                                            <span className="skilldetail">MongoDB</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="infoheadings">
                                            <h6 className="card-title mt-1 empheading">
                                                <CiBank />Bank Details
                                            </h6>
                                            <button className="btnsvg"><FaEdit /></button>
                                        </div>
                                        <hr />
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Bank Name</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>Swiz Intenational Bank</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Bank account no</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>159843014641</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>IFSC Code</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>ICI24504</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="empinfo">
                                                        <div className="empinfotitle">
                                                            <span>Branch</span>
                                                        </div>
                                                        <div className="empinfoname">
                                                            <span>Alabama USA</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="infoheadings">
                                            <h6 className="card-title mt-1 empheading">
                                                <GrDocumentTest />Official Document
                                            </h6>
                                            <button className="btnsvg"><FaEdit /></button>
                                        </div>
                                        <hr />
                                        <div className="officialdocument">
                                            <div className="documentinfo">
                                                <div className="documenttitle">
                                                    <span><AiOutlineFilePdf />Cirtification</span>
                                                </div>
                                            </div>
                                            <div className="documentinfo">
                                                <div className="documenttitle">
                                                    <span><AiOutlineFilePdf />Adhaar Card</span>
                                                </div>
                                            </div>
                                            <div className="documentinfo">
                                                <div className="documenttitle">
                                                    <span><AiOutlineFilePdf />Pan Card</span>
                                                </div>
                                            </div>
                                            <div className="documentinfo">
                                                <div className="documenttitle">
                                                    <span><AiOutlineFilePdf />Offer Latter</span>
                                                </div>
                                            </div>
                                            <div className="documentinfo">
                                                <div className="documenttitle">
                                                    <span><AiOutlineFilePdf />Resume</span>
                                                </div>
                                            </div>
                                            <div className="documentinfo">
                                                <div className="documenttitle">
                                                    <span><AiOutlineFilePdf />Experience Latter</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 colclass">
                                <div className="emptypedetails">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="cardemptype">
                                                <div className="emptypetitle">
                                                    <h6>Monthly Attendance</h6>
                                                    <div className="selectMonth">
                                                        <select name="selectmonth">
                                                            <option value="Jan">Jan</option>
                                                            <option value="Feb">Feb</option>
                                                            <option value="March">March</option>
                                                            <option value="April">April</option>
                                                            <option value="May">May</option>
                                                            <option value="June">June</option>
                                                            <option value="July">July</option>
                                                            <option value="Aug">Aug</option>
                                                            <option value="Sep">Sep</option>
                                                            <option value="Oct">Oct</option>
                                                            <option value="Nov">Nov</option>
                                                            <option value="Dec">Dec</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="leaveEmpDetail">
                                                    <div className="leave">
                                                        <p>Leave</p>
                                                        <span>06</span>
                                                    </div>
                                                    <div className="halfday">
                                                        <p>Half Day</p>
                                                        <span>00</span>
                                                    </div>
                                                    <div className="fullday">
                                                        <p>Full Day</p>
                                                        <span>06</span>
                                                    </div>
                                                    <div className="sortleave">
                                                        <p>Sort Leave</p>
                                                        <span>02</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="cardemptype">
                                                <div className="emptypetitle">
                                                    <h6>Team Member</h6>
                                                </div>
                                                <div className="totalimgnumber">
                                                    <div className="teammemberimg">
                                                        <div className="img">
                                                            <img src={BASEEMPURLS(empdetail?.emp_foto)} alt={empdetail?.emp_foto} />
                                                        </div>
                                                        <div className="imgs">
                                                            <img src={img1} alt={empdetail?.emp_foto} />
                                                        </div>
                                                        <div className="imgs">
                                                            <img src={img2} alt={empdetail?.emp_foto} />
                                                        </div>
                                                        <div className="imgs">
                                                            <img src={img3} alt={empdetail?.emp_foto} />
                                                        </div>
                                                        <div className="imgs">
                                                            <img src={img4} alt={empdetail?.emp_foto} />
                                                        </div>
                                                        <div className="imgs">
                                                            <img src={img5} alt={empdetail?.emp_foto} />
                                                        </div>
                                                    </div>
                                                    <div className="teamnumber">
                                                        <span>+02</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="cardemptype cardemptypes">
                                                <div className="emptypetitle">
                                                    <h6>Birthday</h6>
                                                    <FaBirthdayCake className="birthicons" />
                                                </div>
                                                <div className="empbirthday">
                                                    <span>Friday, 3 November 2023</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="cardemptype cardemptypeb">
                                                <div className="emptypetitle">
                                                    <h6>Last Month Salary</h6>
                                                    <FaMoneyCheckAlt className="birthicons" />
                                                </div>
                                                <div className="lastmonthsalry">
                                                    <span><FaRupeeSign />25000.00</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div >
    )
}

export default EmployeeDetails